
import { Options, Vue } from 'vue-class-component';
import Alert from "@/components/Alert.vue";
import VoucherCheck from "@/components/voucher/VoucherCheck.vue";
import GlobalStore from "@/utils/global-store";
import { VoucherRedemptionCheckResult } from "@/data/voucher";
import { CourseProduct, Product } from "@/data/products";
import { PropType } from "vue";

type VoucherMode = null | 'redeem' | 'order';

type FormErrors = Record<string, string[]>;

export interface StepVoucherData {
    buyVoucher: boolean,
    redeemVoucher: VoucherRedemptionCheckResult | null,
}

@Options({
    props: {
        isCurrent: {
            type: Boolean,
            required: false,
            default: false,
        },
        product: {
            type: Object as PropType<Product|CourseProduct>,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: false,
            default: {},
        },
    },
    components: {
        Alert,
        VoucherCheck,
    },
    emits: [
        'valid',
        'invalid',
        'data',
    ],
    /*emits: {
        success: (value: any) => value === null || typeof value === 'string' || Array.isArray(value),
    },*/
})
export default class StepVoucher extends Vue {
    isCurrent!: boolean
    product!: Product|CourseProduct
    validationErrors!: FormErrors

    buyVoucher = false

    redeemVoucher = false
    voucher: VoucherRedemptionCheckResult|null = null

    onVoucherCodeValid(voucher: VoucherRedemptionCheckResult) {
        this.voucher = voucher;
    }
    onVoucherCodeReset() {
        this.voucher = null;
    }

    get loggedIn() {
        return GlobalStore.data.loggedIn.value;
    }

    get stepData() : StepVoucherData {
        return {
            buyVoucher: this.buyVoucher,
            redeemVoucher: this.redeemVoucher ? this.voucher : null,
        };
    }

    emitState() {
        if( this.redeemVoucher && !this.voucher ) {
            this.$emit('data', null);
            this.$emit('invalid');
        }
        else {
            this.$emit('data', this.stepData);
            this.$emit('valid');
        }
        /*if(  ) {
            this.$emit('valid');
        }
        else {
            this.$emit('invalid');
        }*/
    }

    mounted() {
        this.$watch('voucher', this.emitState, { immediate: true });

        this.$watch('buyVoucher', this.emitState);
        this.$watch('redeemVoucher', this.emitState);

        this.$watch('loggedIn', (loggedIn: boolean) => {
            if( !loggedIn ) {
                this.buyVoucher = true;
            }
        }, { immediate: true });

        this.$watch('product.type', (type: number) => {
            if( type === 2 ) {
                this.buyVoucher = false;
            }
        }, { immediate: true });

        this.$watch('product.voucherable', (voucherable: boolean) => {
            if( !voucherable ) {
                this.buyVoucher = false;
            }
        }, { immediate: true });

        // this.emitState();

        this.$watch('isCurrent', (isCurrent: boolean) => {
            if( !isCurrent ) {
                if( this.redeemVoucher && !this.voucher ) {
                    this.redeemVoucher = false;
                }
            }
        });
    }
}
